module.exports = __webpack_public_path__ + "static/media/October2021Newsletter.70c1f518.pdf";